import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';

export const OFFER_PRICING_STATE_QUERY = gql`
  query quotePricingState(
    $documentVersion: DocumentVersionInput!
    ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        documentId
        revision
        locked
        status
        createdByType
        ...QuotePricingStateFragment
      }
    }
  }
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class OfferPricingStateQuery extends Query<RootQuery> {
  document = OFFER_PRICING_STATE_QUERY;
}
